import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { useProductListing } from './hooks/useProductListing'

export function Heading({ seoH1Text, seoH2Text }: { seoH1Text: string; seoH2Text: string }): React.ReactElement {
  const { query } = useProductListing()

  const fullTextSearch = query.searchableTag ?? query.fullTextSearch ?? undefined

  return (
    <CustomHeading>
      <plume.styles.heading.L as="h1" asDesktop="XL">
        {getTitle({
          fullTextSearch,
          seoText: seoH1Text,
        })}
      </plume.styles.heading.L>
      {seoH2Text && (
        <plume.styles.copy.M as="h2" asDesktop="L">
          {seoH2Text}
        </plume.styles.copy.M>
      )}

      {fullTextSearch && (
        <plume.Link
          underlined
          kind="secondary"
          onClick={() => {
            document.getElementById('product-search-form')?.focus()
          }}
        >
          Modifier ma recherche
        </plume.Link>
      )}
    </CustomHeading>
  )
}

function getTitle({ fullTextSearch, seoText }: { fullTextSearch: string | undefined; seoText: string }): string {
  if (fullTextSearch) {
    return `Résultats pour "${fullTextSearch.valueOf()}"`
  } else {
    return seoText ? seoText : 'Nos produits'
  }
}

const CustomHeading = styled.div`
  ${plume.styles.heading.L} + ${plume.styles.copy.M} {
    margin-top: 10px;
  }

  ${plume.styles.copy.M} {
    max-width: 400px;

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      max-width: 50%;
      margin-bottom: 9px;
    }
  }

  ${plume.Link} {
    ${plume.styles.copy._xSmallStyle};
    display: none;

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      display: inline-flex;
      cursor: pointer;
      position: absolute;
      z-index: 10;
    }
  }
`
